module.exports = __webpack_public_path__ + "img/flomaktsomhet.52db7499.jpg";